export function toggleArrayItem(arr, item) {
  return arr.includes(item) ? arr.filter((i) => i !== item) : [...arr, item];
}

export const swapArrayLoc = (arr, from, to) => {
  let temp = arr[to];
  const newArray = [...arr];
  newArray[to] = arr[from];
  newArray[from] = temp;
  return newArray;
};

export function toggleSetItem(set, item) {
  if (set.has(item)) return new Set([...set].filter((_item) => _item !== item));
  return new Set([...set, item]);
}

export const convertToObjectsArray = (arrays, headers) => {
  const headersIndexToHeaderMapping = headers.reduce((acc, headerKey) => {
    acc[headers.indexOf(headerKey)] = headerKey;
    return acc;
  }, {});
  return arrays.map((valuesArray) => {
    const obj = {};
    valuesArray.forEach(
      (val, index) => (obj[headersIndexToHeaderMapping[index]] = val)
    );
    return obj;
  });
};

export const findLastNonZeroValue = (array) => {
  return (
    array.length -
    array
      .slice()
      .reverse()
      .findIndex((target) => target !== 0)
  );
};
